/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plan: NonNullable<unknown> }} Draftslimitreached2Inputs */

const en_draftslimitreached2 = /** @type {(inputs: Draftslimitreached2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have reached the limit of ${i?.count} drafts on the ${i?.plan} plan.`)
};

const de_draftslimitreached2 = /** @type {(inputs: Draftslimitreached2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast das Limit von ${i?.count} Entwürfen im ${i?.plan}-Plan erreicht.`)
};

/**
* | output |
* | --- |
* | "You have reached the limit of {count} drafts on the {plan} plan." |
*
* @param {Draftslimitreached2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const draftslimitreached2 = /** @type {((inputs: Draftslimitreached2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draftslimitreached2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draftslimitreached2(inputs)
	return de_draftslimitreached2(inputs)
});
export { draftslimitreached2 as "draftsLimitReached" }